import {checkPhoneNumber, checkEmail, checkRePassword, checkNumber, checkPassword} from '../constants/typeCheckFormInput'

const checkFormInput = (value, type) => {

    let result = {
        value : value,
        isError : false,
        msg : '',
    };

    switch(type) {
        case checkPhoneNumber : 
            result.value = value.replace(/[^0-9.,]*/g, "");

            if(value.length < 2) {
                result.value = '62'
            }else{
                if(value.substr(0, 2) !== '62'){
                    result = {
                        ...result,
                        isError : true,
                        msg : 'Format nomor handphone yang Anda masukan salah, gunakan 62 diawal nomor'
                    };
                }
            }
                    
            break;
        case checkEmail :
            let emailRegx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
            let emailValidasi = emailRegx.test(value)
            console.log({value, emailValidasi});
            
        //   if(value.indexOf('@') === -1 || value.indexOf('.') === -1 || value.lastIndexOf('.') < value.lastIndexOf('@')){
            
            if(!emailValidasi){
                result = {
                    ...result,
                    isError : true,
                    msg : 'Format surel tidak sesuai, ex : info@klikcair.com'
                };
            }
            break;
        case checkPassword :
            let passRegx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[^A-Za-z0-9\s])(?=.{8,})/
            let passValidasi = passRegx.test(value)
            console.log({value, passValidasi});

            if(!passValidasi){
                result = {
                    ...result,
                    isError : true,
                    msg : 'Format kata sandi tidak sesuai. Kata sandi harus terdiri dari kombinasi huruf besar, huruf kecil, angka, dan spesial karakter dengan panjang minimal 8 karakter'
                };
            }
            break;
        case checkRePassword :
            result.value = value.repass;

            if(value.pass !== value.repass){
                result = {
                    ...result,
                    isError : true,
                    msg : 'Kata Sandi dengan Konfirmasi Kata Sandi tidak sesuai'
                };
            }
            break;
         case checkNumber :
            result.value = value.replace(/[^0-9.,]*/g, "");
            break;
        default :
            break;
    }

    return result;
}

export default checkFormInput;